// extracted by mini-css-extract-plugin
export default {"courses":"Courses_courses__4Hsss","categories":"Courses_categories__aGqBN"};